import { Tab, Tabs } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import PoFulfilmentDashboard from '.';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPurchaseOrdersFilters } from '../../../containers/actions/common/purchaseOrderAction';
import usePrevious from '../../helpers/previousProps';
import { getFeaturesAccess } from '../../../containers/actions/common/accessControl';

const POFulfilmentTabs = () => {
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(0);
  const [savedFilter, setSavedFilter] = useState({});

  const purchaseOrderFilter = useSelector((state) =>
      state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters?.status
        ? state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters
        : {}
    );

 const screenAccess = useSelector(
      (state) =>
        state.pcmp.common.accessControl.screensAccess?.data?.poFulfilmentDashboard
    );
  
    const featuresAccess = useSelector(
      (state) =>
        state.pcmp.common.accessControl.featuresAccess?.poFulfilmentDashboardFeatures || null
    );

    useEffect(() => {
      if (screenAccess?.screenAccess && !featuresAccess)
        dispatch(getFeaturesAccess(screenAccess?.screenId, 'poFulfilmentDashboardFeatures')); //10 is DS screen ID
      // We can pick up DS screen Id from access screensAccess.data.deliverySchedule.screenId
    }, [dispatch, screenAccess, featuresAccess]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  
  useEffect(() => {
    dispatch(fetchPurchaseOrdersFilters());
  }, [])

  let previousPurchaseOrderFilter = usePrevious(purchaseOrderFilter)

  
  useEffect(() => {
      if (
        JSON.stringify(purchaseOrderFilter) !==
        JSON.stringify(previousPurchaseOrderFilter)
      ) {
        setSavedFilter(purchaseOrderFilter?.save_filter_options && typeof purchaseOrderFilter?.save_filter_options === "object" ? purchaseOrderFilter?.save_filter_options : {})          
      }
  }, [previousPurchaseOrderFilter, purchaseOrderFilter]);
    
  return (
      <React.Fragment>
          <Tabs
    value={tabIndex}
    onChange={handleTabChange}
    indicatorColor='secondary'
    textColor='secondary'
    variant='scrollable'
    scrollButtons='auto'
  >
      <Tab
        label={'Delivery not completed'}
        value={0}
        style={{ textTransform: 'none' }}
          />
          <Tab
        label={'Delivery completed'}
        value={1}
        style={{ textTransform: 'none' }}
      />
          </Tabs>
          
      {tabIndex === 0 && <PoFulfilmentDashboard deliveryCompletionIndicator={false} savedFilter={savedFilter} featuresAccess={featuresAccess} />}

      {tabIndex === 1 && <PoFulfilmentDashboard deliveryCompletionIndicator={true} savedFilter={savedFilter} featuresAccess={featuresAccess} />}
          
      </React.Fragment>
  )
}

export default POFulfilmentTabs